// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__9NdMt","messages":"Chat_messages__1owzw","dateDivider":"Chat_dateDivider__QvTFS"};